import CreateUpdateDebtorForm from "./CreateUpdateDebtorForm";
import { UserProfile } from "Domain/User/Entity/UserProfile";
import { useNavigate, useParams } from "react-router-dom";
import { getDebtorProfile } from "Application/User/DebtorService";
import EntityProvider from "pages/components/Behavior/EntityProvider";
import { Box } from "@mui/material";
import PaymentsIcon from "@mui/icons-material/Payments";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import { useTranslation } from "react-i18next";
import {
  getUrl,
  PAYMENT_PLAN_CREATE,
  PAYMENT_PLAN_LIST,
} from "Infrastructure/config/routesConfig";
import SpeedDialTooltip from "pages/components/SpeedDialTooltip";

export default function EditDebtor() {
  const { t } = useTranslation();
  const { id = "" } = useParams<string>();
  const navigate = useNavigate();

  return (
    <EntityProvider<UserProfile> callback={getDebtorProfile} params={[id]}>
      {(userProfile, setUserData) => (
        <div>
          <Box display={"flex"} justifyContent={"space-between"}>
            <SpeedDialTooltip
              actions={[
                {
                  icon: <PaymentsIcon />,
                  name: t(`TITLE.PAGE.${PAYMENT_PLAN_CREATE}`),
                  action: () => {
                    navigate(
                      getUrl(PAYMENT_PLAN_CREATE) +
                        `?debtor=${userProfile.publicId}`
                    );
                  },
                },
                {
                  icon: <FormatListBulletedIcon />,
                  name: t(`TITLE.PAGE.${PAYMENT_PLAN_LIST}`),
                  action: () => {
                    navigate(
                      getUrl(PAYMENT_PLAN_LIST) +
                        `?debtorId=${userProfile.publicId}`
                    );
                  },
                },
              ]}
            />
          </Box>
          <CreateUpdateDebtorForm debtorProfile={userProfile} />
        </div>
      )}
    </EntityProvider>
  );
}
